import { useSelector } from 'react-redux';

/**
 * Segmented control for "Pre-Filter" vs "All". Replaces the legacy
 * MUI `<ToggleButtonGroup>` + floating outlined `<InfoIcon>` badge
 * (which read as random ornament) with the QHS pill-style segment +
 * a calm inline info hint that reveals the explanation on hover.
 *
 * Behaviour preserved: clicking the same segment is a no-op (we drop
 * the old MUI exclusive-toggle "deselect everything" path so the
 * caller never gets a null alignment), clicking the other segment
 * fires `handleChange(value)`.
 */
const InfoIcon = () => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    <circle cx='12' cy='12' r='10' />
    <line x1='12' y1='16' x2='12' y2='12' />
    <circle cx='12' cy='8' r='0.5' fill='currentColor' />
  </svg>
);

const ToggleButtons = ({ alignment, handleChange }) => {
  const { tables } = useSelector(state => state.i18n);

  const onClick = value => () => {
    if (alignment !== value) handleChange(value);
  };

  return (
    <>
      <div className='qhs-dynh-seg' role='tablist'>
        <button
          type='button'
          className={`qhs-dynh-seg__btn${alignment === 'left' ? ' qhs-dynh-seg__btn--active' : ''}`}
          aria-pressed={alignment === 'left'}
          onClick={onClick('left')}
        >
          {tables?.preFilter || 'Pre-Filter'}
        </button>
        <button
          type='button'
          className={`qhs-dynh-seg__btn${alignment === 'right' ? ' qhs-dynh-seg__btn--active' : ''}`}
          aria-pressed={alignment === 'right'}
          onClick={onClick('right')}
        >
          {tables?.all || 'All'}
        </button>
      </div>
      <span
        className='qhs-dynh-seg__hint'
        title={tables?.preFilterHint || ''}
        aria-label={tables?.preFilterHint || 'Pre-Filter explanation'}
      >
        <InfoIcon />
      </span>
    </>
  );
};

export default ToggleButtons;
